// extracted by mini-css-extract-plugin
export default {"external":"abM02d","deprecatedBorderRadius":"bbM02d","hasAnimation":"cbM02d","container":"dbM02d"};